import { render, staticRenderFns } from "./wx_order_home.vue?vue&type=template&id=4bee9e6d&scoped=true"
import script from "./wx_order_home.vue?vue&type=script&lang=js"
export * from "./wx_order_home.vue?vue&type=script&lang=js"
import style0 from "./wx_order_home.vue?vue&type=style&index=0&id=4bee9e6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee9e6d",
  null
  
)

export default component.exports